exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing_detail_wrap .nav-tabs>li a{padding:10px 30px}.listing_detail_wrap .nav-tabs>li a.active{color:#fff;background:#000}", ""]);

// exports
